const unescapeScript = (string) => {
  return string.replace(/<\/\/script>/g, '<\/script>');
};

const generateAttrToString = (attr) => {
  let result = '';

  Object.keys(attr).forEach((key) => {
    if (result.length) {
      result += ' ';
    }

    result += `${key}="${attr[key]}"`;
  });

  return result;
};

export { unescapeScript, generateAttrToString };



// WEBPACK FOOTER //
// ./app/utils/StringUtils.js